import React ,{Component} from 'react';
import { NavLink,Navigate  } from 'react-router-dom';
import { styled } from '@mui/system';
import { Redirect  } from 'react-router-dom';
import Button from '@mui/material/Button';
import axios from 'axios';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import PersonIcon from '@mui/icons-material/Person';
import Paper from '@mui/material/Paper';  
import Table from '@mui/material/Table'; 
import TableContainer from '@mui/material/TableContainer';  
import TableRow from '@mui/material/TableRow';  
import TableHead from '@mui/material/TableHead';  
import TableCell from '@mui/material/TableCell'; 
import TableSortLabel from '@mui/material/TableSortLabel'; 
import PropTypes from 'prop-types';
import TablePagination from '@mui/material/TablePagination';  
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import TableBody from '@mui/material/TableBody';
import TextField from '@mui/material/TextField';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AddUser from './AddUser';
import FormControl from '@mui/material/FormControl';
import Autocomplete from '@mui/material/Autocomplete';
import Select from '@mui/material/Select';
let strCust=[{title:'Add Customer',year:'0',rowindex:'-1'}];
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}


function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}


const headCells = [

{ id: 'us_firstname', numeric: false,  label: ' Name' },
{ id: 'us_emailid', numeric: false,  label: 'Email' },
{ id: 'us_phone', numeric: false,  label: 'Phone No' },
{ id: 'us_role', numeric: false,  label: 'Role' },
{ id: 'us_us_id', numeric: false,  label: 'Company' },

{ id: '', numeric: false,  label: '' },

]

function EnhancedTableHead(props) {
  const {  order, orderBy,   onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };
  
  
return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = styled(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));


const EnhancedTableToolbar = props => {
const classes = useToolbarStyles();
const { numSelected } = props;

  
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = styled(theme =>({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
 
form: {
    width: '500%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
	 minWidth: 120,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  
   textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  
})
)


export default class AdminUser extends Component {
	constructor(props) {
    super();
this.state = {
logredirect:false,pagename:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:20,rowsPaging:[],
	 search:'',id:'',order:'desc' ,orderBy:'us_id',userdata:[],isblock:'',us_id:0,name:'',redirect:false,
	compemail:'',btndisabled:false,Role:'',Compid:'',cmpid:'',comprauto:[], selectedcompexchange:[],
submitbtn:"Submit",  
      }
	   this.updateuserParent = this.updateuserParent;
	 };
	 updateuserParent = (text) => {this.apicall(this.state.page,this.state.rowsPerPage);  }
  myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});

 }



componentWillMount() {
	
     document.title = "Isifol - Manage Users";
		if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            logredirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
			   this.apicall(this.state.page, this.state.rowsPerPage);
		  }
		  else{
	    
		this.PageAccessCheckApi();
		  }
		
		
}
		
		 this.props.parentdasCallback("Manage Users~");
      
		
		

	}
	
	
	
PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=6')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
        this.apicall(this.state.page, this.state.rowsPerPage);
		 
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}


	
	
	apicall(page,rowsPerPage){
 let strurl="";
 
if(localStorage.getItem("ISIrole")!=="1")
{
	strurl="&us_cmp_id="+localStorage.getItem("ISIcmpid");
}
else{
	strurl="&us_cmp_id="+this.state.cmpid;
}
 
  
  axios.get(localStorage.getItem("ISIurl")+'ajaxuser.php?action=getall&us_firstname='+this.state.name+'&StartIndex='+page+'&PageSize='+rowsPerPage+strurl+'&us_role='+this.state.Role)
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  userdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			});
     }
	 else{
		   this.setState({userdata:[],totaldata:0});
	 }
   
    });

}
handleClickSearch=()=>{
 this.apicall(this.state.page,this.state.rowsPerPage); 
} 

handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'desc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'desc'
   
  });
};

handleChangePage = (event, newPage) => {  

  
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	 
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };
  
  
   deleteUser(usid){  
  
		let r = window.confirm("Do you really want to Delete?");
		 if(r == true){ //sign Out logic
				 var formData = new FormData(); 
					 formData.append('action','Delete')					 
					 formData.append('us_id',usid)
					 formData.append('userid',localStorage.getItem("ISIuserid"))
					  axios.post(localStorage.getItem("ISIurl")+"ajaxuser.php", formData, {
						}).then(res => {
					
							this.apicall(this.state.page,this.state.rowsPerPage);
				  
					
					
							});
		 }
 }
 
   
unblockuser(usid){
	 
	 let r = window.confirm("Do you really want to Unblock?");
		 if(r == true){ //sign Out logic
				 var formData = new FormData(); 
					 formData.append('action','Inactive')
					 formData.append('us_id',usid)
					 formData.append('us_isactive',0)
					 formData.append('userid',localStorage.getItem("ISIuserid"))
					 
					axios.post(localStorage.getItem("ISIurl")+"ajaxuser.php", formData, {
						}).then(res => {
					
							this.apicall(this.state.page,this.state.rowsPerPage);
 
							});
		 }
 
 } 
 
blockuser(usid){
	 
	 let r = window.confirm("Do you really want to block?");
		 if(r == true){ //sign Out logic
				 var formData = new FormData(); 
					 formData.append('action','Inactive')
					 formData.append('us_id',usid)
					 formData.append('us_isactive',1)
					 formData.append('userid',localStorage.getItem("ISIuserid"))
					axios.post(localStorage.getItem("ISIurl")+"ajaxuser.php", formData, {
						}).then(res => {
					
							this.apicall(this.state.page,this.state.rowsPerPage);
   
				  
					
					
							});
		 }
 
 } 
 
    Useraddbox(val){
        this.setState({ usid: val });  
  
         setTimeout(() => this.refs.AddUser.handleClickOpen(),500);

      }
onInputcompChange = (event, newTextValue) => {
	if(newTextValue!==" "){
	  this.setState({Compid:newTextValue})
	} 
}

onTagscompexchange = (event, values) => {
	if(values!==" " && values!==null && values.rowindex!="-1"){
		this.setState({
		Compid:values.year,
		 cmpid:values.year,
		selectedcompexchange:values})
		
	}
	
	else
	{
		 this.setState({ Compid:'',cmpid:'',selectedcompexchange:[]})
	}
	
}
onloadCompBind=(event)=>{

	 if(event.target.value.length>0 )
	{
	 axios.get(localStorage.getItem("ISIurl")+'ajaxcompany.php?action=CompAuto&cmp_name='+event.target.value)
  .then(resp => { 
  

	 var rowsArray = resp.data;
	 rowsArray.map((row, i) => {
			 
		 const items = {
        title:row.title,
          year:row.year,
		  cmpid:row.year,		  
		  rowindex:row.rowindex,
           
        };
		
		 const cusfound = strCust.some(el => el.year === row.year);
		 if (!cusfound) strCust.push(items)
		  
		 });
	 strCust = strCust.sort((a, b) => a.rowindex < b.rowindex ? 1 : -1)
		  this.setState({comprauto:strCust},
		  
		  ()=>{})
  });
	 
	}
}
render() {
	
  if (this.state.redirect === true) {
    return <Navigate to={this.state.pagename} />;
  }

  return (
    <React.Fragment>
     

 
 <div className="searchbox">

<ul>


 <li>
        <p>Search</p>
        <p>
          <TextField
            variant="outlined"
            fullWidth
			className="txtbox"
            value={this.state.name}
            id="name"
            inputProps={{ tabIndex: "1", maxLength: 150 }}
            name="name"
            onChange={this.myChangeHandler}
            InputProps={{
              endAdornment: (
                <SearchOutlinedIcon style={{ marginLeft: 8 }} />
              ),
            }}
          />
        </p>
      </li>
	 <li>
                <p> Role</p>
                <p>
                  <FormControl className="stadrp">
                    <Select
                      native
                      variant="outlined"
                      margin="normal" value={this.state.Role}
                      onChange={this.myChangeHandler}
                      id="type"
                      inputProps={{ tabIndex: "2" }}
                      className="txtbox"
                      name="Role"
                    >
                      <option value="">Select Role</option>
                      <option value={1}>Admin</option>
                      <option value={2}>Manager</option>
                      <option value={3}>Sales</option>
                    </Select>
                  </FormControl>
                </p>
              </li>	  
			 
			 {localStorage.getItem("ISIrole")==="1" && (
			 <li style={{"width":"20%"}}>
			  <p><span className="validation">*</span>Company</p>
		<p>
			<Autocomplete
			  id="free-solo-demo"
			  
			  className="txtbox"  inputValue={this.state.Compid}
			  options={this.state.comprauto}   onInputChange={this.onInputcompChange}
			   onChange={this.onTagscompexchange} 
				value={this.state.selectedcompexchange}
			  renderInput={(params) => (
				<TextField {...params} className="txtbox" onChange={this.onloadCompBind}  variant="outlined" />
			  )}
		 getOptionLabel={(option) => option.title || ""}

        renderOption={(props, option: AcOption) => (
        <React.Fragment>
          <table width='200%' >
          
            <tbody> {option.rowindex!=="-1" &&(
              <tr {...props}>
                <td width='10%'>{option.title}</td>
         
				
              </tr> )}
			 
			  
            </tbody>
          </table>
        </React.Fragment>
      )}
    />
	
	
	
	</p>
			  
			  </li>
			 )}
<li>
<p>&nbsp;</p>
	 <p className="searchbutton">
       <Button
  type="submit"
  variant="contained"
  className="frmSecondarybtn"
  onClick={this.handleClickSearch}
>
 
  Search 
</Button>
&nbsp;
<a href="/#/Useradd" >
<Button
  type="submit"
  variant="contained"
  className="frmSecondarybtn"
 
>
 
  New 
</Button>
 </a>
</p>
</li>

 </ul>
</div>
<div className="clear"></div>

  
    
      
      <Paper className={useStyles.root}>
        <TableContainer className={useStyles.container}>
          <Table stickyHeader aria-label="sticky table">
            <EnhancedTableHead
              order={this.state.order}
              orderBy={this.state.orderBy}
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.userdata.length}
            />
            <TableBody>
              {stableSort(this.state.userdata, getSorting(this.state.order, this.state.orderBy)).map((item, index) => {
				 
			   if (this.state.totaldata > 0) {
                  return ( <React.Fragment>
				   {item.us_role!="1" &&(
                    <TableRow key={index}>
                      <TableCell>{item.us_firstname}</TableCell>
                      <TableCell>{item.us_emailid}</TableCell>
                      <TableCell>{item.us_phone}</TableCell>
                      <TableCell>{item.role}</TableCell>
                      <TableCell>{item.cmp_name}</TableCell>

                     <TableCell align="left">
   {(
  (localStorage.getItem("ISIrole") === "2" || localStorage.getItem("ISIrole") === "1") || 
  (
    (localStorage.getItem("ISIrole") === "3" || localStorage.getItem("ISIrole") === "4") &&
    item.us_role !== "2"
  )
) && (
  <React.Fragment>
    <Button
      variant="contained"
      className="frmSecondarybtn"
      endIcon={<EditIcon />}
      href={`#/Useradd?usid=${item.us_id}`}
    >
      Edit
    </Button>

    &nbsp;&nbsp;&nbsp;&nbsp;
    <Button
      variant="contained"
      className="frmthirdbtn"
      onClick={() => { this.deleteUser(item.us_id) }}
      endIcon={<DeleteIcon />}
    >
      Delete
    </Button>
    &nbsp;

    {item.us_isactive === "0" && (
      <Button
        variant="contained"
        className="frmSecondarybtn"
        onClick={() => { this.blockuser(item.us_id) }}
        endIcon={<PersonOffIcon />}
      >
       Active
      </Button>
    )}
    {item.us_isactive === "1" && (
      <Button
        variant="contained"
        className="frmSecondarybtn"
        onClick={() => { this.unblockuser(item.us_id) }}
        endIcon={<PersonIcon />}
      >
        Inactive
      </Button>
    )}
  </React.Fragment>
)}
</TableCell>
                    </TableRow>
				   )}  </React.Fragment>);
                } else {
                  return (
                    <TableRow>
                      <TableCell colspan="5">
                        <h3>No Records</h3>
                      </TableCell>
                    </TableRow>
                  );
                }
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[50, 100, 200, 300, 400]}
          component="div"
          count={this.state.totaldata}
          rowsPerPage={this.state.rowsPerPage}
          page={this.state.page}
          onPageChange={this.handleChangePage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
        />
      </Paper>
    </React.Fragment>
  );
}
   
}